
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCEY2eD1lXKLcLfKEsmKpKl_PUKDepjnrY",
  authDomain: "riverside-3fd46.firebaseapp.com",
  projectId: "riverside-3fd46",
  storageBucket: "riverside-3fd46.appspot.com",
  messagingSenderId: "240846770539",
  appId: "1:240846770539:web:6b7e9505e3047b7ac7fc2e",
};

// Initialize Firebase
initializeApp(firebaseConfig);

export const db = getFirestore();
